class QueryTouchDetails {

    private _touches: QueryTouchPoint[];
    private _time: number;

    public get touches() { return this._touches; }
    public get time() { return this._time; }

    constructor(touches: QueryTouchPoint[]) {
        this._time = new Date().getTime();
        this._touches = touches;
    }

    toString() {
        let str = "Touch:\r\n";

        if(this._touches !== undefined) {
            str+= `Started at:\t ${this._time}\r\n`;
            for(let curr of this._touches) {
                str += `TouchStart:\tx: ${curr.x}\t y:${curr.y}\r\n`
            }
        }
        return str;
    }
}